(function() {
    'use strict';

    angular.module('news')
        .controller('NewsCreateController', NewsCreateController);

    NewsCreateController.$inject = ['$state', 'notificationSrvc', 'newsDataSrvc', 'newsMessagesConst', 'errorNotificationSrvc'];

    function NewsCreateController($state, notificationSrvc, newsDataSrvc, newsMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            title_pl: [],
            title_en: [],
            title_de: [],
            title_cpde: [],
            title_cpen: [],
            content_pl: [],
            content_de: [],
            content_en: [],
            content_cpde: [],
            content_cpen: [],
            publication_date: [],
            nonFieldErrors: [],
        };
        self.newsData = {
            title_pl: '',
            title_en: '',
            title_de: '',
            title_cpde: '',
            title_cpen: '',
            content_pl: '',
            content_de: '',
            content_en: '',
            content_cpde: '',
            content_cpen: '',
            publication_date: '',
        };

        self.createNews = createNews;
        self.cleanErrors = cleanErrors;

        function createNews() {
            newsDataSrvc.create(
                self.newsData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", newsMessagesConst.add);
                    $state.go('layout.news.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
